<div *ngIf="heeftOndernemingen()">

    <form [formGroup]="specJaarrekeningFg">
        <div formArrayName="specificatieJaarrekening">
            <div *ngFor="let spec of specificatieJaarrekening.controls; let i = index "
                 [formGroupName]="i">
                <div formGroupName="opbouw">
                    <div class="row">
                        <div class="col col-1">
                            @if (!this.heeftSamenwerkingsverband) {
                                <p>Eindvermogen volgens {{ labelBalansSlot }}</p>
                            } @else {
                                <p>Aandeel in eindvermogen volgens {{ labelBalansSlot }}</p>
                            }
                        </div>
                        <div class="col-1">
                            @if (!this.heeftSamenwerkingsverband) {
                                <snelstart-venture-fiscaal-feature-spec-eindvermogen
                                        [partner]="partner"></snelstart-venture-fiscaal-feature-spec-eindvermogen>
                            } @else {
                                <div></div>
                            }
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              [disabledControl]="true"
                                                              align="right"
                                                              class="custom-input-150"
                                                              formControlName="eindVermogen"
                                                              id="eindVermogen"
                                                              prefix="€">
                            </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>
                    <div class="row">
                        <div class="col col-1">
                            @if (!this.heeftSamenwerkingsverband) {
                                <p>Beginvermogen volgens {{ labelBalansOpening }}</p>
                            } @else {
                                <p>Aandeel in beginvermogen volgens {{ labelBalansOpening }}</p>
                            }
                        </div>
                        <div class="col-1">
                            @if (!this.heeftSamenwerkingsverband) {
                                <snelstart-venture-fiscaal-feature-spec-beginvermogen
                                        [partner]="partner"></snelstart-venture-fiscaal-feature-spec-beginvermogen>
                            } @else {
                                <div></div>
                            }
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control [decimals]="0"
                                                              [disabledControl]="true"
                                                              align="right"
                                                              class="custom-input-150"
                                                              formControlName="beginVermogen"
                                                              id="beginVermogen"
                                                              prefix="€">
                            </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="tellingFG">
        <div class="row">
            <div class="col col-1">
                <p>Vermogensverschil</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [disabledControl]="true"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="verschilVermogen"
                                                  id="verschilVermogen"
                                                  prefix="€">
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
            <div class="col-4"></div>
        </div>
    </form>

    <form [formGroup]="specJaarrekeningFg">
        <div class="row">
            <div formArrayName="specificatieJaarrekening">
                <div *ngFor="let spec of specificatieJaarrekening.controls; let i = index "
                     [formGroupName]="i">
                    <div formGroupName="opbouw">
                        <div class="row">
                            <div class="col col-1">
                                <p>Bij: Totaal priv&eacute;onttrekkingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control [decimals]="0"
                                                                  [disabledControl]="true"
                                                                  align="right"
                                                                  class="custom-input-150"
                                                                  formControlName="totaleOnttrekkingen"
                                                                  id="totaleOnttrekkingen"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>
                        <div class="row">
                            <div class="col col-1">
                                <p>Af: Totaal priv&eacute;stortingen</p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control [decimals]="0"
                                                                  [disabledControl]="true"
                                                                  align="right"
                                                                  class="custom-input-150"
                                                                  formControlName="totaleStortingen"
                                                                  id="totaleStortingen"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="tellingFG">
        <div class="row">
            <div class="col col-1">
                <p><b>Winst volgens vermogensvergelijking</b></p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  [disabledControl]="true"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="winstVolgensVergelijking"
                                                  id="winstVolgensVergelijking"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
            <div class="col-4"></div>
        </div>
    </form>

    <form [formGroup]="specJaarrekeningFg">
        <div class="space20"></div>

        @if (!this.heeftSamenwerkingsverband) {
            <div class="pt-1" formArrayName="specificatieJaarrekening">
                <div *ngFor="let spec of specificatieJaarrekening.controls; let i = index "
                     [formGroupName]="i">
                    <div formGroupName="opbouw">
                        <div class="row">
                            <div class="col col-1">
                                <p><b>Ter controle: Winst volgens de resultatenrekening</b></p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        [disabledControl]="true"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="winstVolgensResultatenRekening"
                                        id="winstVolgensResultatenRekening"
                                        prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                </div>
            </div>
        }
        @if (this.heeftSamenwerkingsverband) {
            <div class="pt-1" formArrayName="specificatieJaarrekening">
                <div *ngFor="let spec of specificatieJaarrekening.controls; let i = index "
                     [formGroupName]="i">
                    <div formGroupName="opbouw">
                        <div class="row">
                            <div class="col col-1">
                                <p><b>Ter controle: Winstaandeel samenwerkingsverband</b></p>
                            </div>
                            <div class="col-2">
                                <snelstart-ui-number-form-control
                                        [decimals]="0"
                                        [disabledControl]="true"
                                        align="right"
                                        class="custom-input-150"
                                        formControlName="aandeelInWinstVolgensResultatenRekening"
                                        id="aandeelInWinstVolgensResultatenRekening"
                                        prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                            <div class="col-4"></div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </form>

    <form [formGroup]="tellingFG">
        <div class="pt-2" style="width: 75%">
            <div *ngIf="calculateVerschilWinst() !== 0">
                @if (!this.heeftSamenwerkingsverband) {
                    <snelstart-ui-alert type="warning">
                        De winst volgens vermogensvergelijking
                        € {{ this.tellingFG.get('winstVolgensVergelijking')?.value | number:'1.0-0' }}
                        is niet gelijk aan de winst volgens de resultatenrekening
                        € {{ this.specJaarrekeningFg.get('specificatieJaarrekening.0.opbouw.winstVolgensResultatenRekening')?.value | number:'1.0-0' }}
                        . <br/>
                        Het verschil is
                        € {{ this.tellingFG.get('winstVolgensVergelijking')?.value - this.specJaarrekeningFg.get('specificatieJaarrekening.0.opbouw.winstVolgensResultatenRekening')?.value | number:'1.0-0' }}
                        . Pas de priv&eacute;stortingen en/of -onttrekkingen of de resultatenrekening aan.
                    </snelstart-ui-alert>
                } @else {
                    <snelstart-ui-alert type="warning">
                        De winst volgens vermogensvergelijking
                        € {{ this.tellingFG.get('winstVolgensVergelijking')?.value | number:'1.0-0' }}
                        is niet gelijk aan het winstaandeel in het samenwerkingsverband
                        € {{ this.specJaarrekeningFg.get('specificatieJaarrekening.0.opbouw.aandeelInWinstVolgensResultatenRekening')?.value | number:'1.0-0' }}
                        . <br/>
                        Het verschil is
                        € {{ this.tellingFG.get('winstVolgensVergelijking')?.value - this.specJaarrekeningFg.get('specificatieJaarrekening.0.opbouw.aandeelInWinstVolgensResultatenRekening')?.value | number:'1.0-0' }}
                        . Pas de priv&eacute;stortingen en/of -onttrekkingen of het winstaandeel aan.
                    </snelstart-ui-alert>
                }
            </div>

            <div *ngIf="calculateVerschilWinst() === 0">
                <snelstart-ui-alert type="success">
                    @if (!heeftSamenwerkingsverband) {
                        De winst volgens vermogensvergelijking is gelijk aan de winst volgens de resultatenrekening.
                    } @else {
                        De winst volgens vermogensvergelijking is gelijk aan het winstaandeel in het samenwerkingsverband.
                    }
                </snelstart-ui-alert>
            </div>

        </div>
    </form>
</div>


<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>

